import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeLeading } from 'redux-saga/effects';

import { fromDto as contactFromDto } from '../../../models/adapters/ContactAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { contactFetched, contactFetchFailed, ContactFetchResponsePayload, fetchContact, FetchContactPayload } from '../../actions/setting/fetchContact';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function createContactFetchtResponseAction(placeUuid: string, response): Action<ContactFetchResponsePayload> {
  const { error, contact } = response;
  const timestamp = moment();
  if (!error) {
    return contactFetched({ contact: contactFromDto(contact), timestamp });
  }
  return contactFetchFailed({ placeUuid, timestamp });
}

function* fetchContactSaga({ payload }: Action<FetchContactPayload>) {
  const token = yield getAuthenticationToken();
  const { placeUuid, fetchState } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getContact, token, { placeUuid });
  const action = createContactFetchtResponseAction(placeUuid, response);
  yield put(action);
}

export default function* watchFetchContactSaga() {
  yield takeLeading(fetchContact, fetchContactSaga);
}
